import { OutlinedLayout } from "./BaseLayouts";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
/**
 * A layout for a `TextInput` with a static label and an outline.
 * @example
 *   import { OutlinedTextInputLayout, TextInput } from "@brexhq/component-library";
 *   const someComponent = () => {
 *     return (
 *       <TextInput
 *         {...params}
 *         layoutRenderer={OutlinedTextInputLayout}
 *       />
 *     );
 *   }
 *
 *   // Or use the pre-configured TextInput
 *   const anotherComponent = () => {
 *     return (
 *       <TextInput
 *         {...params}
 *       />
 *     );
 *   }
 */
export const OutlinedTextInputLayout = ({
  isFocused,
  hasValue,
  size,
  inputProps,
  label,
  beforeInput,
  afterInput,
  onClick,
  disabled,
  error,
  warning,
  success,
  assistiveContent,
  hideAdditionalContent,
  assistiveContentOnFocus,
  additionalContentOverflow,
  redactionStrategy,
  highlightHasValue,
  textAlign,
  variant,
  afterLabel
}) => _jsx(OutlinedLayout, {
  isFocused,
  hasValue,
  size,
  inputProps,
  label,
  beforeInput,
  afterInput,
  onClick,
  disabled,
  error,
  warning,
  success,
  assistiveContent,
  assistiveContentOnFocus,
  additionalContentOverflow,
  redactionStrategy,
  hideAdditionalContent,
  highlightHasValue,
  textAlign,
  variant,
  afterLabel
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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